// extracted by mini-css-extract-plugin
export var container = "_cx-0";
export var popoverContent = "_cx-1";
export var tosLink = "_cx-2";